import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import {
  FormControlLabel,
  Radio,
  Typography,
  RadioGroup,
  FormControl,
  Checkbox,
  Box,
  Fade,
  Grid,
} from '@material-ui/core'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import parseMax from 'libphonenumber-js/max'
import CMSText, { isPrismicText, prismicText } from '../Global/CMSText'
import useTakeBackStyle from '../../components/TakeBack/TakeBack.style'
import Loader from '../Loader/Loader'
import Button from '../Button/Button'
import LoginForm from '../UserForm/LoginForm'
import { loginUser, registerUser, getUser } from '@/redux/actions/user'
import RegisterForm from '../UserForm/RegisterFrom'
import ForgotPasswordForm from '../UserForm/ForgotPasswordForm'
import ConnectedForm from '../UserForm/ConnectedForm'
import TakeBackPrice from './TakeBackPrice'
import {
  getAddress,
  postAddress,
  putAddress,
} from '@/redux/actions/addressUser'
import ImgKitHandler from '../ImgKitHandler/ImgKitHandler'
import { setFullLocale, thumbnailRatio, transformLocale } from '@/utils/utils'
import { PrismicAccount } from '@/interfaces/common/prismicAccount'
import { RootState } from '@/redux/reducers/rootReducer'
import { GetMapDispatchTypes } from '@/interfaces/common/redux'
import AddressForm from '../Information/AddressForm'
import { useAddress } from '@/hooks/useAddress'
import { useRouter } from 'next/router'
import { LOCAL_STORAGE_KEYS } from '@/utils/constants'

type Tprops = ReturnType<typeof mapStateToProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps> & {
    takeback: any
    t: any
    account: PrismicAccount
    priceValue: number
    handleRemoveProduct: any
    handleAddProduct: any
    takeBackProductsInformations: any
    handleLogisticsTakeBackData: any
    formattedCurrentLocale: any
    productStateObject: any
    showLoginForm: any
    setShowLoginForm: any
    main: any
    funnel: any
    secondStepError: boolean
  }

const mapStateToProps = (state: RootState) => ({
  user: state.user,
  addressUser: state.addressUser,
  parameters: state.parameters,
  takeBack: state.takeBack,
})

const mapDispatchToProps = {
  registerUser: registerUser,
  loginUser: loginUser,
  getUser: getUser,
  getAddress: getAddress,
  postAddress: postAddress,
  putAddress: putAddress,
}
const TakeBackSecondStep = ({
  takeback,
  t,
  loginUser,
  getUser,
  parameters,
  user,
  registerUser,
  account,
  takeBack,
  handleRemoveProduct,
  addressUser,
  getAddress,
  postAddress,
  putAddress,
  handleAddProduct,
  takeBackProductsInformations,
  handleLogisticsTakeBackData,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  formattedCurrentLocale,
  productStateObject,
  showLoginForm,
  setShowLoginForm,
  main,
  funnel,
  secondStepError,
}: Tprops) => {
  const classes = useTakeBackStyle()
  const router = useRouter()
  const currentLocale = router?.locale ? router.locale : 'fr'
  const localPrismic = setFullLocale(router?.locale)
  const loading = takeBack?.loading
  const [register, setIsRegisterForm] = useState(false)
  const [hasRegistered, setHasRegistered] = useState(false)
  const [hasLogin, setHasLogin] = useState(false)
  const [confirmAddress, setConfirmAddress] = useState(false)
  const [loginError, setLoginError] = useState(false)
  const [isConnected, setIsConnected] = useState(false)
  const [errorAccountDisabled, setErrorAccountDisabled] = useState(false)
  const [login, setIsLoginForm] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [errorEmailUsed, setErrorEmailUsed] = useState(false)
  const [errorPhone, setHasErrorPhone] = useState(false)
  const [forgot, setIsForgotForm] = useState(false)
  const [locationValue, setLocationValue] = useState(null)
  const [cgu, setCGU] = useState(false)
  const [cguBis, setCGUBis] = useState(false)
  const [disabledButton, setDisableButton] = useState(true)
  const [currentIncentive, setCurrentIncentive] = useState(0)
  const [currentTotalAmount, setCurrentTotalAmount] = useState(0)
  const [address, setAddress] = useState('')
  const [details, setDetails] = useState('')
  const [postalCode, setPostalCode] = useState('')
  const [town, setTown] = useState('')
  const [userCountryCode, setUserCountryCode] = useState('')
  const [selectedCountry, setSelectedCountry] = useState(
    parameters?.countries?.[0].code || currentLocale.toUpperCase()
  )
  const smallImgWidth = main?.data?.small_image_size
  const aspectRatio = thumbnailRatio(main?.data?.thumbnail_ratio)
  const showAddressVerification =
    takeback?.data?.take_back_location_verification_enabled
  const { trackPageView } = useMatomo()
  const takeBackSimplified = process.env.SIMPLIFIED_TAKE_BACK
  useEffect(() => {
    let total = 0
    takeBackProductsInformations.map((product) => {
      total = total + product.amount
    })
    setCurrentTotalAmount(total)
  }, [takeBackProductsInformations])

  useEffect(() => {
    if (user?.user?.id && !hasLogin) {
      if (showAddressVerification) getAddress()
      setIsConnected(true)
      setIsLoginForm(false)
      setIsRegisterForm(false)
    } else {
      setIsConnected(false)
    }
  }, [user?.user])

  const { address: inputAddress } = useAddress()

  useEffect(() => {
    if (isConnected && showLoginForm && user?.user?.address?.city) {
      if (showAddressVerification) {
        setAddress(user?.user?.address?.street)
        setDetails(user?.user?.address?.details)
        setPostalCode(user?.user?.address?.postcode)
        setTown(user?.user?.address?.city)
        setUserCountryCode(user?.user?.address?.countryCode)

        if (!hasRegistered) {
          setConfirmAddress(true)
        }
      } else {
        const data = {
          firstName: user?.user?.firstName.trim(),
          lastName: user?.user?.lastName.trim(),
          // gender: user?.user?.gender,
          phoneNumber: user?.user?.address?.phoneNumber,
          street: user?.user?.address?.street,
          postcode: user?.user?.address?.postcode,
          details: user?.user?.address?.details,
          // email: user?.user?.email.trim(),
          city: user?.user?.address?.city.trim(),
          countryCode: user?.user?.address?.countryCode.toUpperCase(),
        }
        onConnectedSubmit(data)
      }

      localStorage.setItem('email', user?.user?.email)
    }
  }, [showLoginForm, isConnected, user?.user])
  const handleShowLoginForm = () => {
    setShowLoginForm(true)
    window?.scroll(0, 0)
  }

  const switchForm = (id) => {
    setIsRegisterForm(false)
    setIsConnected(false)
    setLoginError(false)
    setHasError(false)
    setErrorEmailUsed(false)
    setErrorAccountDisabled(false)
    setHasErrorPhone(false)
    setIsForgotForm(false)
    setIsLoginForm(false)
    switch (id) {
      case 1:
        setIsRegisterForm(true)
        break
      case 3:
        setIsConnected(true)
        break
      case 4:
        setIsLoginForm(true)
        break
      case 5:
        setIsForgotForm(true)
        break
      default:
        break
    }
  }

  const submitLogin = async (data) => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    const log = await loginUser(data)
    setLoginError(false)
    if (log.type === 'LOGIN_USER_FAILURE') {
      if (log?.err?.response?.data?.message === 'Account is disabled.') {
        setErrorAccountDisabled(true)
      } else {
        setLoginError(true)
        setIsConnected(false)
        setIsLoginForm(true)
      }
    } else {
      setLoginError(false)
      setIsRegisterForm(false)
      setIsConnected(true)
      setIsLoginForm(false)
      if (log.token.token) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, log.token.token)
        getUser()
      }
    }
  }

  const submitRegistration = async (data) => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    setHasError(false)
    setErrorEmailUsed(false)
    setHasErrorPhone(false)
    if (
      ['MOBILE', 'FIXED_LINE_OR_MOBILE'].includes(
        parseMax(data?.phoneNumber).getType()
      )
    ) {
      const register = await registerUser(data)
      if (register.type === 'REGISTER_USER_SUCCESS') {
        if (!parameters?.items?.isAccountVerificationRequired) {
          const dataLogin = {
            email: data.email,
            password: data.plainPassword,
          }
          submitLogin(dataLogin)
          setIsRegisterForm(false)
          setIsConnected(true)
          setHasRegistered(true)
          setHasLogin(false)
        } else {
          setIsRegisterForm(false)
          setIsLoginForm(true)
          setHasRegistered(true)
        }
      } else {
        if (
          register?.err?.response?.data?.errors?.email?.[0] ===
          'This email is already used.'
        ) {
          setErrorEmailUsed(true)
        } else {
          setHasError(true)
        }
      }
    } else {
      setHasErrorPhone(true)
    }
  }

  const calculateTotalAmount = (currentTotalAmount, currentIncentive) => {
    return parseFloat(
      (
        currentTotalAmount +
        (currentTotalAmount * currentIncentive) / 100
      ).toFixed(0)
    )
  }

  const buildUserInfosRMS = (user, locationValue) => ({
    firstname: user.user.firstName,
    lastname: user.user.lastName,
    phone: user.user.phoneNumber,
    gender: user.user.gender,
    company: `${user.user.firstName} ${user.user.lastName}`,
    email: user.user.email,
    voucherLocation: locationValue,
  })

  const onConnectedSubmit = (data) => {
    setHasLogin(false)
    const totalAmount = calculateTotalAmount(
      currentTotalAmount,
      currentIncentive
    )
    const userInfoOMS = {
      firstName: user?.user?.firstName,
      lastName: user?.user?.lastName,
      phoneNumber: user?.user?.phoneNumber,
    }
    const userInfosRMS = buildUserInfosRMS(user, locationValue)
    if (data) {
      const modifiedData = {
        address: data.street,
        zipcode: data.postcode,
        country:
          takeback?.data?.enable_take_back_country && selectedCountry
            ? selectedCountry
            : data.countryCode,
        city: data.city,
        locale: transformLocale(localPrismic),
      }
      const sendInfos = {
        ...modifiedData,
        ...userInfosRMS,
        totalAmount,
      }

      postAddress({ ...userInfoOMS, ...data })
      //NEXT STEP HERE ONLY AFTER validate address
      handleLogisticsTakeBackData(sendInfos, currentIncentive)
    }
  }

  const onConfirmAddress = (data) => {
    setHasLogin(false)
    const totalAmount = calculateTotalAmount(
      currentTotalAmount,
      currentIncentive
    )
    const userInfosRMS = buildUserInfosRMS(user, locationValue)
    if (data) {
      const modifiedData = {
        address: inputAddress.payload.street,
        zipcode: inputAddress.payload.postcode,
        city: inputAddress.payload.city,
        country: inputAddress.payload.countryCode,
        locale: transformLocale(localPrismic),
      }
      const sendInfos = {
        ...modifiedData,
        ...userInfosRMS,
        totalAmount,
      }

      if (addressUser?.items?.length > 0) {
        putAddress(
          {
            firstName: user.user.firstName,
            lastName: user.user.lastName,
            phoneNumber: user.user.phoneNumber,
            ...inputAddress.payload,
          },
          addressUser.items[0].id
        )
      } else {
        const userInfoOMS = {
          firstName: user?.user?.firstName,
          lastName: user?.user?.lastName,
          phoneNumber: user?.user?.phoneNumber,
        }
        postAddress({ ...userInfoOMS, ...data })
      }

      //NEXT STEP HERE ONLY AFTER validate address
      handleLogisticsTakeBackData(sendInfos, currentIncentive)
    }
  }

  const handleLocation = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentLocation = takeback?.data?.take_back_locations.find(
      (location) =>
        prismicText(location?.location_api_key) === event.target.value
    )
    const currentIncentiveLocation = currentLocation.incentive
    setCurrentIncentive(currentIncentiveLocation)
    setLocationValue(event.target.value)
  }

  useEffect(() => {
    if (locationValue === null) {
      setDisableButton(true)
    } else if (!cgu) {
      setDisableButton(true)
    } else if (isPrismicText(takeback?.data?.text_confirmation) && !cguBis) {
      setDisableButton(true)
    } else {
      setDisableButton(false)
    }
  }, [locationValue, cgu, cguBis])

  const changeCGU = () => {
    setCGU(!cgu)
  }
  const changeCGUBis = () => {
    setCGUBis(!cguBis)
  }

  useEffect(() => {
    trackPageView({ documentTitle: 'Take Back Program - Second Step' })
    window?.scrollTo(0, 0)
  }, [])
  return (
    <div
      className={clsx(
        classes.takeBackSecondStepContainer,
        'takeBack__secondStep__container'
      )}
    >
      <div className={clsx(classes.takeBackSecondStep, 'takeBack__secondStep')}>
        {loading ? (
          <Fade in>
            <Box textAlign={'center'}>
              <Loader />
              <CMSText
                data={takeback?.data?.waiting_price_text}
                defaultText={t('texts:takeBack:waiting_price_text')}
              />
            </Box>
          </Fade>
        ) : (
          <>
            {!showLoginForm ? (
              <>
                <Typography
                  variant="body1"
                  component="div"
                  className={clsx(
                    classes.takeBackOffer,
                    'takeBack-offer__title'
                  )}
                >
                  <CMSText
                    data={takeback?.data?.offer_announcement_text}
                    defaultText={t('texts:takeBack:offer_announcement_text')}
                  />
                </Typography>
                <div>
                  {takeBackProductsInformations.map((product, index) => {
                    return (
                      <div key={index} className={classes.productItem}>
                        <div className={classes.productImage}>
                          <div data-ratio={aspectRatio}>
                            <ImgKitHandler
                              classes={classes.imageSize}
                              imagePaths={
                                product.image.path
                                  ? product.image
                                  : takeBack.response?.images[0]
                              }
                              settings={{
                                width: smallImgWidth,
                                ar: aspectRatio?.substring(3),
                                defaultImage: main?.data?.default_image,
                              }}
                            />
                          </div>
                        </div>
                        <div className={classes.productDetails}>
                          <div
                            className={clsx(
                              classes.productDescription,
                              'product__description'
                            )}
                          >
                            <Typography
                              variant="h3"
                              component={'p'}
                              className={clsx(
                                classes.productName,
                                'product__name'
                              )}
                            >
                              {product.productName}
                            </Typography>
                            <Typography
                              variant="body2"
                              className={clsx(
                                classes.productMeta,
                                'product__meta'
                              )}
                            >
                              <CMSText
                                asText
                                data={takeback?.data?.reference}
                                defaultText={t('texts:takeBack:reference')}
                              />{' '}
                              {product.labelReference}
                            </Typography>
                            {!takeBackSimplified && (
                              <Typography
                                variant="body2"
                                className={clsx(
                                  classes.productMeta,
                                  'product__meta'
                                )}
                              >
                                {product.size}
                              </Typography>
                            )}
                            {!takeBackSimplified && (
                              <Typography
                                variant="body2"
                                component={'div'}
                                className={clsx(
                                  classes.productStatePrice,
                                  'product__state-price'
                                )}
                              >
                                <div
                                  className={clsx(
                                    classes.productMeta,
                                    'product__meta',
                                    'product__state'
                                  )}
                                >
                                  {productStateObject[product.quality]?.title}
                                </div>
                                <TakeBackPrice
                                  price={product.amount}
                                  incentiveValue={currentIncentive}
                                />
                              </Typography>
                            )}
                          </div>
                          {!takeBackSimplified && (
                            <Button
                              disableRipple
                              size="small"
                              onClick={() => handleRemoveProduct(index)}
                              className={clsx(
                                classes.productDelete,
                                'product__delete'
                              )}
                            >
                              <CloseOutlinedIcon />
                            </Button>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className={classes.totalContainer}>
                  {!takeBackSimplified && (
                    <div>
                      <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        className={clsx(
                          classes.SecondStepButton,
                          'takeBack__add-product-btn'
                        )}
                        onClick={() => handleAddProduct()}
                      >
                        <CMSText
                          asText
                          data={takeback?.data?.add_product_button}
                          defaultText={t('texts:takeBack:add_product')}
                        />
                      </Button>
                    </div>
                  )}
                  {!takeBackSimplified && (
                    <div
                      className={clsx(
                        classes.totalPrice,
                        'products__total__amount'
                      )}
                      id="takeBack_total_amount"
                    >
                      <CMSText
                        asText
                        data={takeback?.data?.total_price}
                        defaultText={t('texts:takeBack:total')}
                      />
                      &nbsp;:&nbsp;
                      <TakeBackPrice
                        price={currentTotalAmount}
                        incentiveValue={currentIncentive}
                      />
                    </div>
                  )}
                </div>
                <div className={classes.locationContainer}>
                  {takeback?.data?.enable_take_back_country && (
                    <>
                      <Typography
                        className={clsx(
                          classes.locationTitle,
                          'takeBack__location__title'
                        )}
                      >
                        <CMSText
                          data={takeback?.data?.take_back_country_title}
                          defaultText={t(
                            'texts:takeBack:take_back_location_title'
                          )}
                        />
                      </Typography>
                      <div>
                        <FormControl className={clsx(classes.formControl)}>
                          <select
                            value={selectedCountry}
                            onChange={(event) =>
                              setSelectedCountry(event.target.value)
                            }
                            className={clsx(
                              classes.selector,
                              'takeBack__select'
                            )}
                          >
                            {parameters?.countries?.length > 0 &&
                              parameters?.countries.map((option, index) => {
                                return (
                                  <option key={index} value={option?.code}>
                                    {option?.name}
                                  </option>
                                )
                              })}
                          </select>
                        </FormControl>
                        <Typography
                          className={clsx(
                            classes.locationTitle,
                            'takeBack__location__title'
                          )}
                        ></Typography>
                      </div>
                    </>
                  )}
                  <div className={classes.locationTitleContainer}>
                    <Typography
                      className={clsx(
                        classes.locationTitle,
                        'takeBack__location__title'
                      )}
                    >
                      <CMSText
                        data={takeback?.data?.take_back_location_title}
                        defaultText={t(
                          'texts:takeBack:take_back_location_title'
                        )}
                      />
                    </Typography>
                    {prismicText(takeback?.data?.take_back_location_explanation)
                      .length > 0 && (
                      <Typography
                        component="div"
                        className={clsx(
                          classes.locationDesc,
                          'takeBack__location__explanation'
                        )}
                      >
                        <CMSText
                          data={takeback?.data?.take_back_location_explanation}
                          defaultText={t(
                            'texts:takeBack:take_back_location_desc'
                          )}
                        />
                      </Typography>
                    )}
                  </div>
                  <FormControl
                    component="fieldset"
                    className={clsx('takeBack__location__choice')}
                  >
                    {takeback?.data?.take_back_locations.map(
                      (location, index) => {
                        //hide location if only available for specific countries
                        if (
                          location.only_available_for.length &&
                          takeback?.data?.enable_take_back_country
                        ) {
                          const countriesAvailable =
                            location.only_available_for[0].text
                              .split(',')
                              .map((country) => country.trim())
                          if (!countriesAvailable.includes(selectedCountry)) {
                            return
                          }
                        }
                        return (
                          <RadioGroup
                            row
                            key={index}
                            value={locationValue}
                            onChange={handleLocation}
                            className={clsx(
                              classes.formLabelRow,
                              'radio',
                              'takeBack__formLabelRow',
                              'takeBack__formLabelRow--location'
                            )}
                          >
                            <FormControlLabel
                              value={prismicText(location?.location_api_key)}
                              control={<Radio color="primary" />}
                              label={
                                <Typography variant="caption">
                                  <CMSText
                                    data={location?.take_back_location}
                                  />
                                </Typography>
                              }
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        )
                      }
                    )}
                  </FormControl>
                </div>
                <div
                  className={clsx(
                    classes.formLabelRow,
                    'checkbox',
                    'takeBack__formLabelRow',
                    'takeback__formLabelRow--cgu'
                  )}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={cgu}
                        onChange={changeCGU}
                        name="cgu_agree"
                        data-testid={'cgu_agree'}
                      />
                    }
                    label={
                      <Typography variant={'body2'} component={'div'}>
                        <CMSText data={takeback?.data?.text_cgu} />
                      </Typography>
                    }
                  />
                </div>
                {isPrismicText(takeback?.data?.text_confirmation) && (
                  <div
                    className={clsx(
                      classes.formLabelRow,
                      'checkbox',
                      'takeBack__formLabelRow',
                      'takeback__formLabelRow--cgu'
                    )}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={cguBis}
                          onChange={changeCGUBis}
                          name="cgu_agree"
                          data-testid={'cgu_agree_bis'}
                        />
                      }
                      label={
                        <Typography variant={'body2'} component={'div'}>
                          <CMSText data={takeback?.data?.text_confirmation} />
                        </Typography>
                      }
                    />
                  </div>
                )}
                <div
                  className={clsx(
                    classes.center,
                    classes.takeBackSecondStepSubmit,
                    'takeBack__secondStep__submit'
                  )}
                >
                  <Button
                    size="small"
                    variant="contained"
                    color="secondary"
                    className={classes.SecondStepButton}
                    disabled={disabledButton}
                    onClick={() => handleShowLoginForm()}
                  >
                    <CMSText
                      asText
                      data={takeback?.data?.accept_offer_button}
                      defaultText={t('texts:takeBack:accept_offer_button')}
                    />
                  </Button>
                </div>
              </>
            ) : (
              <>
                {login && (
                  <LoginForm
                    hasRegistered={hasRegistered}
                    loginError={loginError}
                    text={account?.data}
                    takeBackTitle={takeback?.data?.subtitle}
                    isTakeBack={true}
                    t={t}
                    switchForm={switchForm}
                    isFunnel={false}
                    submitLogin={submitLogin}
                    errorAccountDisabled={errorAccountDisabled}
                  />
                )}
                {register && (
                  <RegisterForm
                    submitRegistration={submitRegistration}
                    switchForm={switchForm}
                    isLoading={user.loading}
                    errorPhone={errorPhone}
                    t={t}
                    errorEmailUsed={errorEmailUsed}
                    hasError={hasError}
                    text={account?.data}
                    isTakeBack={true}
                    takeBackTitle={takeback?.data?.register_text}
                    isFunnel={false}
                  />
                )}
                {showAddressVerification && confirmAddress && (
                  <>
                    <Grid
                      container
                      spacing={1}
                      className={classes.marginBottom}
                    >
                      <Grid item xs={12}>
                        <Typography variant={'h4'} align="center">
                          {user?.user?.firstName}
                          {', '}
                          {prismicText(
                            takeback?.data?.text_location_verification_title,
                            t('texts:takeBack:address_check_required')
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                      <AddressForm
                        account={true}
                        prefill={true}
                        defaultAddress={{
                          street: address,
                          details: details,
                          postcode: postalCode,
                          city: town,
                          countryCode: userCountryCode,
                        }}
                        hideAdditionalAddress={
                          funnel?.data?.hide_additional_address
                        }
                      />
                    </Grid>
                    <div className={classes.validAddress}>
                      <Button
                        size="small"
                        variant="contained"
                        color="secondary"
                        className={classes.SecondStepButton}
                        onClick={() =>
                          onConfirmAddress({
                            street: address,
                            postcode: postalCode,
                            city: town,
                            countryCode: userCountryCode,
                          })
                        }
                      >
                        <CMSText
                          asText
                          data={takeback?.data?.text_confirm_location_button}
                          defaultText={t(
                            'texts:takeBack:confirm_address_button'
                          )}
                        />
                      </Button>
                    </div>
                  </>
                )}
                {isConnected && (
                  <>
                    {!hasLogin ? (
                      <ConnectedForm
                        onSubmit={
                          hasRegistered
                            ? onConnectedSubmit
                            : addressUser?.items?.length === 0 ||
                              addressUser?.items === undefined
                            ? onConnectedSubmit
                            : () => setConfirmAddress(true)
                        }
                        text={account?.data}
                        t={t}
                        switchForm={switchForm}
                        userFirstName={user?.user?.firstName}
                        hasAddress={user?.user}
                        funnel={funnel}
                        isTakeBack
                      />
                    ) : (
                      <div>
                        <Loader />
                      </div>
                    )}
                  </>
                )}
                {forgot && (
                  <ForgotPasswordForm
                    isFunnel={false}
                    text={account?.data}
                    t={t}
                    switchForm={switchForm}
                  />
                )}
                {secondStepError && (
                  <Typography color="error" align="center">
                    {t('texts:takeBack:step_2_error')}
                  </Typography>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(TakeBackSecondStep)
